<template>
  <div class="group-overview">
    <div class="header">
      <DateSelect v-model="date"
                  @input="getAllocations"
                  :debounceTime="400" />
    </div>

    <div class="groups p-5">
      <div class="group mb-6"
           v-for="(group, index) in groupedAllocations"
           :key="index">
        <h3 class="text is-size-4 mb-5">Gruppe {{ index }}</h3>

        <!-- <calendar-entry :entry="allocation"
                        :allocationTypes="allocationTypes"
                        :circles-lookup="circles"
                        @click.native="entrySidebarOpen(entry)" /> -->
        <AllocationUser class="mb-4"
                        v-for="(allocation, allocationIndex) in group"
                        :key="allocationIndex"
                        :color="getColor(allocation)"
                        :header="getTitle(allocation)"
                        :body="getCircleTitle(allocation)"
                        @click.native="openSidebar(allocation)" />
      </div>

    </div>
  </div>
</template>

<style lang="scss">
.header {
  @include center-full;

  background: $gray;
  padding: 1.25em;

  .date-select {
    width: 17em;
  }
}
</style>

<script>
import DateSelect from "@/components/common/DateSelect.vue";
import AllocationUser from "./group-overview/AllocationUser.vue";
import { mapActions, mapGetters } from "vuex";
import CalendarEntry from "./calendar-small/CalendarEntry.vue";
import { logEvaluated } from "@/util/devtools";
import groupBy from "lodash/groupBy";

export default {
  name: "calendar-small",
  components: {
    DateSelect,
    AllocationUser,
    //CalendarEntry,
  },
  data: () => ({
    date: new Date(),
    groupedAllocations: [],
  }),
  async mounted() {
    await this.loadMyUser();
    this.getAllocations();
  },
  methods: {
    ...mapActions("allocations", ["getAllocationForGroupOnDate","updateAllocation", "setAllocations"]),
    ...mapActions("entrySidebar", ["entrySidebarOpen", "entrySidebarOpenAsync"]),
    ...mapActions("appUsers", ["loadMyUser"]),
    async getAllocations() {

      await this.loadAllocationsForGroup();
    },
    getTitle(allocation){
      if(allocation.replacementName) {
        if(allocation.replacementId === this.currentUser.id) {
          return ` ${allocation.replacementNumber} - ${allocation.replacementName} afløser: ${allocation.employee.number} - ${allocation.employee.name}`
        } else{
          return `${allocation.employee.number} - ${allocation.employee.name} afløst af: ${allocation.replacementNumber} - ${allocation.replacementName}`
        }
      }
      return `${allocation.employee.number} - ${allocation.employee.name}`
    },
    getColor(allocation) {
      if(!allocation) {
        return "ivory";
      }
      if(!allocation.circle) {
        if(allocation.allocationType === "OFFDAY" || allocation.allocationType === "OFFDAYREPLACEMENT"){
          return "ivory";
        }
        return "timeoff";
      }

      if(allocation.replacementId) {
        return "green";
      }

      return allocation.circleColor;
    },
    getCircleTitle(allocation){
      if(!allocation) {
        return "fri";
      }
      if(!allocation.circle) {
        if(allocation.allocationType === "OFFDAY"){
          return "fri";
        }
        if(allocation.allocationType === "OFFDAYREPLACEMENT") {
          return "ledig";
        }
        return "ferie";
      }
      return allocation.circle.title;
    },
    async openSidebar(entry) {
      if(!entry.employeeId) {
        return;
      }

      entry.canEdit = entry.employeeId === this.myAppUser.id;

      await this.entrySidebarOpenAsync(entry)
        .then(async (response) => {
        if(response.action === "update") {
          const { model } = response;
          if(model) {            
            await this.updateAllocation(model);
          }
          await this.loadAllocationsForGroup();
        }

        if(response.action === "notification") {          
          await this.loadAllocationsForGroup();
        }
      })
      .catch((error) => console.error(error));
    },
    async loadAllocationsForGroup(){
      var compare = (a, b) => {
        let noa = a.employee.orderNumber;
        let nob = b.employee.orderNumber;
        if(a.employee.groups.find(o => o.groupId === this.groupFilter)){
          noa = a.employee.groups.find(o => o.groupId === this.groupFilter).orderNumber;
        }
        if(b.employee.groups.find(o => o.groupId === this.groupFilter)){
          nob = b.employee.groups.find(o => o.groupId === this.groupFilter).orderNumber;
        }

        if(noa < nob){
          return -1;
        }

        if(noa > nob){           
          return 1;
        }

        return 0;
      };

      const groupId = (this.viewAsGroup) ? this.viewAsGroup.id : this.myAppUser.groupId;

      const dto = {
        date: this.date,
        forGroup: groupId,
        asEmployee: (this.viewAsEmployee) ? this.viewAsEmployee.id : undefined
      };

      await this.getAllocationForGroupOnDate(dto);

      const sortedAllocations = this.allocationsOnDate.sort(compare);
      const group = groupBy(
        sortedAllocations, // TODO: Only main circles if replacement
        (allocation) => allocation.employee.groupName
      );

      this.groupedAllocations = group;
    }
  },
  computed: {
    ...mapGetters(["currentUser", "viewAsGroup", "viewAsEmployee"]),
    ...mapGetters("appUsers", ["myAppUser"]),
    ...mapGetters("employees", ["employees"]),
    ...mapGetters("metadata", ["allocationTypes"]),
    ...mapGetters("circles", ["circleApiState", "circles"]),
    ...mapGetters("allocations", [
      "allocationsOnDate",
      "allocations",
    ]),
  },
  watch: {
    async 'viewAsGroup'() {
      await this.getAllocations();
    }
  }
};
</script>